import React, { useEffect } from "react";
import { Container} from "react-bootstrap";
import { Link } from "react-router-dom";

function TechniFooter() {
  

  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
  }, []);

  return (    
    <footer className="techniFoot">
        <Container>
            <div className="text-center position-relative">
                <p className="mb-0">© Copyright 2022 Good Guys Home Service</p>
                <div className="techniFoot_top">
                    <Link  onClick={() => {window.scrollTo({top: 0, left: 0, behavior: 'smooth'});}}><em className="gg-arrow-down"/></Link>
                    To the top
                </div>                
            </div>            
        </Container>
    </footer>
  );
}
  
export default TechniFooter;